import type { PropsWithChildren } from 'react'

import {
  DrawerContentStyled,
  type IDrawerContentStyled,
} from './styles/DrawerContentStyled'

export interface IDrawerContent extends IDrawerContentStyled {}

export const DrawerContent = ({
  children,
  ...props
}: PropsWithChildren<IDrawerContent>) => (
  <DrawerContentStyled {...props}>{children}</DrawerContentStyled>
)

DrawerContent.displayName = 'DrawerContent'
